module.exports = __webpack_public_path__ + "static/media/yellowParrot.70fdcfb6.png";